import { invoke } from '@forge/bridge'
import type { RadarDataStorage, RadarMetadata } from '../../../types'

// Unified export function: always exports full backup (all radars, config, data)
export async function exportRadarData(returnStringOnly = false) {
  // Call backend resolver to get all radar data in backup format
  const exportResult = await invoke<{
    schemaVersion: number
    radars: RadarMetadata[]
    data: Record<number, RadarDataStorage>
  }>('exportAllRadars', {})

  const dataStr = JSON.stringify(exportResult, null, 2)

  if (returnStringOnly) {
    return dataStr
  }

  const dataBlob = new Blob([dataStr], { type: 'application/json' })
  const url = URL.createObjectURL(dataBlob)
  const now = new Date()
  const date = now.toISOString().slice(0, 19).replace('T', '_')
  const link = document.createElement('a')
  link.href = url
  link.download = `TechRadar_Backup_${date}.json`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
